import { useState } from 'react';
import AddressBody from '../../../../features/Address/AddressBody';
import LibModal from '../../../../features/LibModal/LibModal';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { useAdminInfo } from '../AdminInfoProvider';
import { handleAddressSaveOpe } from './AddressOperation';
import AddressSameAsRadio from './AddressSameAsRadio';

function AddressAddModal({ show, setShow, title, customerData }) {
    const [loading, setLoading] = useState(false);
    const { setMessage } = useTemplate();
    const { setInfoReloadKey } = useAdminInfo();
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        addressType: title?.toString()?.toLowerCase(),
        userId: customerData?.id,
        Status: 'active'
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSameAs = (e, type) => {
        const addressType = title?.toString()?.toLowerCase();
        setFormData({
            ...formData,
            ...customerData?.addresses?.[type],
            addressType
        });
    };

    const handleSaveAddress = (e) => {
        e.preventDefault();
        setLoading(true);
        handleAddressSaveOpe(formData, setIsError)
            .then(({ title: message }) => {
                setMessage({ type: 'success', text: message });
                setInfoReloadKey((d) => d + 1);
                setShow(false);
                setLoading(false);
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString(0) });
                setLoading(false);
            });
    };
    FocusControl(isError, setIsError, formData);

    if (!show) return null;
    return (
        <LibModal title={`${title} Address`} setOpen={setShow} className="sm:w-[570px]">
            <form onSubmit={handleSaveAddress}>
                {/* Same as other address */}
                <div className="flex justify-start items-center gap-3 pb-5">
                    <AddressSameAsRadio
                        isShow={title?.toString()?.toLowerCase() !== 'administrative'}
                        type="administrative"
                        onClick={(e, type) => handleSameAs(e, type)}
                    />
                    <AddressSameAsRadio
                        isShow={title?.toString()?.toLowerCase() !== 'billing'}
                        type="billing"
                        onClick={(e, type) => handleSameAs(e, type)}
                    />
                    <AddressSameAsRadio
                        isShow={title?.toString().toLowerCase() !== 'technical'}
                        type="technical"
                        onClick={(e, type) => handleSameAs(e, type)}
                    />
                </div>
                {/* Address Body */}
                <AddressBody formData={formData} onChange={handleChange} />
                <p className="text-xs text-error mt-3">All Fields Are Required!</p>
                {/* Address Footer */}
                <div className="flex flex-row justify-end items-center gap-4 my-4">
                    <ButtonCancel title="Cancel" onClick={() => setShow(false)} />
                    <ButtonPrimary btnType="submit" title="Save" loading={loading} />
                </div>
            </form>
        </LibModal>
    );
}

export default AddressAddModal;
